import { useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import useAuthUser from './useAuthUser';
import SignOutLink from './signOutLink';
import { dashboardPath } from '../../constants';

// Shared header for the dashboard and every sub-dashboard: an eyebrow +
// heading on the left, "Signed in as" + Sign Out on the right, with an
// optional "back to Dashboard" link above it for anything that isn't the
// top-level Dashboard itself.
const DashboardHeader = ({ eyebrow, heading, showBackLink = false, backTo = dashboardPath, backLabel = 'Dashboard' }) => {
    const theme = useTheme();
    const { user } = useAuthUser();

    const eyebrowStyle = {
        fontFamily: theme.typography.fontFamily,
        fontSize: '12px',
        fontWeight: 700,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color: theme.palette.brand.brass,
        margin: '0 0 6px',
    };

    const headingStyle = {
        fontFamily: theme.typography.secondaryFontFamily,
        fontWeight: 600,
        color: theme.palette.primary.dark,
        fontSize: 'min(8vw, 34px)',
        margin: 0,
    };

    return (
        <div style={{ marginBottom: '24px' }}>
            {showBackLink && (
                <Link
                    to={backTo}
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        fontFamily: theme.typography.fontFamily,
                        fontSize: '13px',
                        fontWeight: 600,
                        color: theme.palette.primary.main,
                        textDecoration: 'none',
                        marginBottom: '16px',
                    }}
                >
                    <ArrowBackIosNewIcon sx={{ fontSize: '11px' }} />
                    {backLabel}
                </Link>
            )}

            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    gap: '16px',
                }}
            >
                <div>
                    <div style={eyebrowStyle}>{eyebrow}</div>
                    <h1 style={headingStyle}>{heading}</h1>
                </div>

                {user && (
                    <div style={{ textAlign: 'right' }}>
                        <div
                            style={{
                                fontFamily: theme.typography.paragraphFontFamily,
                                fontSize: '13px',
                                color: theme.palette.text.secondary,
                                marginBottom: '4px',
                            }}
                        >
                            Signed in as {user.email}
                        </div>
                        <SignOutLink />
                    </div>
                )}
            </div>
        </div>
    );
};

export default DashboardHeader;
